// (B) 플레인 Spinner — antd Spin 대체(순수 시각). Loading3Quarters 회전 인디케이터 인라인(@ant-design/icons 비의존).
//
// ⚠ .om-spin* 는 live antd Spin 소스가 다수(OmwSpinner 28 + antd List 내부 loading[ThreadList·ninegqlUI batch9]
// + etv localization[D3]) + antd CSS-in-JS 공존. 따라서 이중 클래스 병존: .om-spin*(kit base 시각, styles/omwSpinner.css)
// + .om-spin*(소비처 SCSS 공유) 를 함께 부여 → 소비처 SCSS 무변경, .ant→.om rename 은 List/etv/ninegqlUI 이관 시 일괄.
import type { OmwSpinnerProps } from '../api/OmwSpinner'
import { cx } from './cx'
import '../styles/omwSpinner.css'

// antd Loading3QuartersOutlined 대체(회전 3/4 원 SVG).
function Indicator() {
  return (
    <span className="om-spin-dot">
      <svg
        className="om-spin-indicator-svg"
        viewBox="0 0 1024 1024"
        width="1em"
        height="1em"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M512 1024c-69.1 0-136.2-13.5-199.3-40.2C251.7 958 197 921 150 874c-47-47-84-101.7-109.8-162.7C13.5 648.2 0 581.1 0 512c0-19.9 16.1-36 36-36s36 16.1 36 36c0 59.4 11.6 117 34.6 171.3 22.2 52.4 53.9 99.5 94.3 139.9 40.4 40.4 87.5 72.2 139.9 94.3C395 940.4 452.6 952 512 952c59.4 0 117-11.6 171.3-34.6 52.4-22.2 99.5-53.9 139.9-94.3 40.4-40.4 72.2-87.5 94.3-139.9C940.4 629 952 571.4 952 512c0-59.4-11.6-117-34.6-171.3a370.4 370.4 0 00-94.3-139.9 370.4 370.4 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.2C772.3 66 827 103 874 150c47 47 84 101.8 109.8 162.7 26.7 63.1 40.2 130.2 40.2 199.3s-13.5 136.2-40.2 199.3C958 772.3 921 827 874 874c-47 47-101.7 84-162.7 109.8-63.1 26.7-130.2 40.2-199.3 40.2z" />
      </svg>
    </span>
  )
}

function Spin({
  spinning,
  size,
  tip,
  className,
  style,
}: {
  spinning: boolean
  size?: 'small' | 'default' | 'large'
  tip?: OmwSpinnerProps['tip']
  className?: string
  style?: OmwSpinnerProps['style']
}) {
  return (
    <span
      className={cx(
        'om-spin',
        'om-spinner',
        spinning && 'om-spin-spinning',
        spinning && 'om-spin-spinning',
        size === 'large' && 'om-spin-lg',
        size === 'small' && 'om-spin-sm',
        className,
      )}
      style={style}
      aria-live="polite"
      aria-busy={spinning}
    >
      <Indicator />
      {tip != null && <div className="om-spin-text">{tip}</div>}
    </span>
  )
}

export function PlainSpinner({
  spinning = true,
  size,
  tip,
  wrapperClassName,
  className,
  style,
  children,
}: OmwSpinnerProps) {
  // 자식이 없으면 standalone spinner(spinning=false 면 미표시, antd 동일).
  if (children == null) {
    return spinning ? (
      <Spin spinning={spinning} size={size} tip={tip} className={className} style={style} />
    ) : null
  }

  // 자식이 있으면 nested-loading 오버레이(spinning 시 자식 blur + 스피너 오버레이).
  return (
    <div
      className={cx('om-spin-nested-loading', 'om-spinner-nested', wrapperClassName)}
      style={style}
    >
      {spinning && (
        <div>
          <Spin spinning={spinning} size={size} tip={tip} className={className} />
        </div>
      )}
      <div
        className={cx('om-spin-container', spinning && 'om-spin-blur', spinning && 'om-spin-blur')}
      >
        {children}
      </div>
    </div>
  )
}
